// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CartItems-module-ageVerificationBlock-AuEOs{margin-bottom:20px}.CartItems-module-cartItemWrapper-aANFJ{flex-direction:column;align-items:flex-start;gap:0;gap:var(--des-dimension-gap-and-padding-general-near-none, 0);align-self:stretch;border-radius:8px;border-radius:var(--des-radius-card, 8px);background:#fbfbfb;background:var(--des-color-fill-panel-level1, #fbfbfb)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ageVerificationBlock": "CartItems-module-ageVerificationBlock-AuEOs",
	"cartItemWrapper": "CartItems-module-cartItemWrapper-aANFJ"
};
export default ___CSS_LOADER_EXPORT___;
